var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "form",
      {
        attrs: { "data-vv-scope": "custom-document", autocomplete: "off" },
        on: {
          submit: function($event) {
            $event.preventDefault()
          }
        }
      },
      [
        _c("h2", { staticClass: "mb-10" }, [_vm._v("Oficio CORE")]),
        _c("div", { staticClass: "row form-group" }, [
          _c(
            "label",
            { staticClass: "col-3 col-form-label", attrs: { for: "sender" } },
            [_vm._v("De")]
          ),
          _c(
            "div",
            { staticClass: "col-4" },
            [
              _c("b-form-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: {
                  state: _vm.errors.has("custom-document.sender")
                    ? false
                    : null,
                  "data-cy": "sender",
                  "data-vv-as": "DE",
                  name: "sender",
                  type: "text"
                },
                model: {
                  value: _vm.formData.sender,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "sender", $$v)
                  },
                  expression: "formData.sender"
                }
              }),
              _vm.errors.has("custom-document.sender")
                ? _c(
                    "div",
                    {
                      staticClass:
                        "con-text-validation span-text-validation-danger v-enter-to"
                    },
                    [
                      _c("span", { staticClass: "span-text-validation" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.errors.first("custom-document.sender")) +
                            " "
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row form-group" }, [
          _c(
            "label",
            { staticClass: "col-3 col-form-label", attrs: { for: "receiver" } },
            [_vm._v("A")]
          ),
          _c(
            "div",
            { staticClass: "col-4" },
            [
              _c("b-form-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: {
                  state: _vm.errors.has("custom-document.receiver")
                    ? false
                    : null,
                  "data-cy": "receiver",
                  "data-vv-as": "A",
                  name: "receiver",
                  type: "text"
                },
                model: {
                  value: _vm.formData.receiver,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "receiver", $$v)
                  },
                  expression: "formData.receiver"
                }
              }),
              _vm.errors.has("custom-document.receiver")
                ? _c(
                    "div",
                    {
                      staticClass:
                        "con-text-validation span-text-validation-danger v-enter-to"
                    },
                    [
                      _c("span", { staticClass: "span-text-validation" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.errors.first("custom-document.receiver")
                            ) +
                            " "
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row form-group" }, [
          _c(
            "label",
            { staticClass: "col-3 col-form-label", attrs: { for: "receiver" } },
            [_vm._v("Cargo")]
          ),
          _c(
            "div",
            { staticClass: "col-4" },
            [
              _c("b-form-input", {
                attrs: {
                  "data-cy": "position",
                  "data-vv-as": "position",
                  name: "position",
                  type: "text"
                },
                model: {
                  value: _vm.formData.position,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "position", $$v)
                  },
                  expression: "formData.position"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Antecedentes" } },
                [
                  _c("b-form-textarea", {
                    attrs: {
                      "data-cy": "background",
                      name: "background",
                      maxLength: "500",
                      rows: "3",
                      type: "text"
                    },
                    model: {
                      value: _vm.formData.background,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "background", $$v)
                      },
                      expression: "formData.background"
                    }
                  }),
                  _c("div", { staticClass: "text-right" }, [
                    _c(
                      "small",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: "Contador de caracteres",
                            expression: "'Contador de caracteres'"
                          }
                        ]
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.formData.background.length) + "/500 "
                        )
                      ]
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Materia *" } },
                [
                  _c("b-form-textarea", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      state: _vm.errors.has("custom-document.matter")
                        ? false
                        : null,
                      "data-cy": "matter",
                      "data-vv-as": "materia",
                      name: "matter",
                      maxLength: "500",
                      rows: "3",
                      type: "text"
                    },
                    model: {
                      value: _vm.formData.matter,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "matter", $$v)
                      },
                      expression: "formData.matter"
                    }
                  }),
                  _c("div", { staticClass: "row justify-content-between" }, [
                    _c("div", { staticClass: "col-md-6 text-left" }, [
                      _vm.errors.has("custom-document.matter")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "con-text-validation span-text-validation-danger v-enter-to"
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "span-text-validation" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "custom-document.matter"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ]),
                    _c("div", { staticClass: "col-md-6 text-right" }, [
                      _c(
                        "small",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Contador de caracteres",
                              expression: "'Contador de caracteres'"
                            }
                          ]
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.formData.matter.length) + "/500 "
                          )
                        ]
                      )
                    ])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Descripción *" } },
                [
                  _c("editor-text", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    ref: "description",
                    attrs: {
                      danger: _vm.errors.has("custom-document.description"),
                      "danger-text": _vm.errors.first(
                        "custom-document.description"
                      ),
                      "data-cy": "description",
                      "data-vv-as": "descripción",
                      "max-length": _vm.maxLengthDescription,
                      name: "description",
                      "with-counter": ""
                    },
                    model: {
                      value: _vm.formData.description,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "description", $$v)
                      },
                      expression: "formData.description"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("div", { staticClass: "col-md-6 mt-2" }, [
            _vm._v(" Orientación de documento "),
            _c("div", { staticClass: "row mt-3" }, [
              _c(
                "div",
                { staticClass: "col-md-4" },
                [
                  _c(
                    "vs-radio",
                    {
                      attrs: {
                        "vs-name": "portrait",
                        "vs-value": "Portrait",
                        "data-cy": "portrait"
                      },
                      model: {
                        value: _vm.formData.orientation,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "orientation", $$v)
                        },
                        expression: "formData.orientation"
                      }
                    },
                    [_vm._v(" Vertical ")]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-md-4" },
                [
                  _c(
                    "vs-radio",
                    {
                      attrs: {
                        "vs-name": "landscape",
                        "vs-value": "Landscape",
                        "data-cy": "landscape"
                      },
                      model: {
                        value: _vm.formData.orientation,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "orientation", $$v)
                        },
                        expression: "formData.orientation"
                      }
                    },
                    [_vm._v(" Horizontal ")]
                  )
                ],
                1
              )
            ])
          ]),
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "row align-items-center mt-5" }, [
              _vm._m(0),
              _c(
                "div",
                { staticClass: "col-md-3 align-items-end" },
                [
                  _c("UploadFile", {
                    attrs: {
                      permission: "*",
                      accept: "application/pdf, .doc, .docx, .xlsx, .ppt",
                      text: "Seleccionar documentos",
                      "upload-to": "ed",
                      "button-class": {
                        "btn-block": true,
                        "mb-5": _vm.errors.has("custom-document.fileName")
                      },
                      "container-class": "w-100"
                    },
                    on: {
                      input: function($event) {
                        return _vm.addOthersFile()
                      }
                    },
                    model: {
                      value: _vm.fileOthers,
                      callback: function($$v) {
                        _vm.fileOthers = $$v
                      },
                      expression: "fileOthers"
                    }
                  })
                ],
                1
              )
            ]),
            _c(
              "div",
              { staticClass: "row align-items-center mt-1" },
              [
                _c(
                  "div",
                  { staticClass: "col-md-3 align-items-end" },
                  [
                    _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "has-permission",
                            rawName: "v-has-permission",
                            value: "ED060",
                            expression: "'ED060'"
                          },
                          {
                            name: "b-modal",
                            rawName: "v-b-modal",
                            value: "add-file-repository",
                            expression: "'add-file-repository'"
                          }
                        ],
                        staticClass: "btn-icon mt-1",
                        attrs: {
                          variant: "secondary",
                          "data-cy": "from-repository"
                        }
                      },
                      [
                        _c("feather-icon", { attrs: { icon: "ServerIcon" } }),
                        _vm._v(" Desde el repositorio ")
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._l(_vm.formData.attachments, function(file) {
                  return _c("div", { key: file.id, staticClass: "col-2" }, [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column align-items-center" },
                      [
                        _c("vs-icon", {
                          attrs: {
                            icon: "description",
                            size: "45px",
                            color: "primary"
                          }
                        }),
                        _c(
                          "b",
                          { staticClass: "text-truncate w-100 text-center" },
                          [_vm._v(_vm._s(file.name))]
                        ),
                        _c("vs-button", {
                          attrs: {
                            color: "danger",
                            type: "flat",
                            icon: "clear"
                          },
                          on: {
                            click: function($event) {
                              return _vm.removeOthersFile(file.id)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ])
                })
              ],
              2
            ),
            !!_vm.error.messageOthers
              ? _c(
                  "div",
                  {
                    staticClass:
                      "con-text-validation span-text-validation-danger\n        vs-input--text-validation-span v-enter-to text-left"
                  },
                  [
                    _c("span", { staticClass: "span-text-validation" }, [
                      _vm._v(" " + _vm._s(_vm.error.messageOthers) + " ")
                    ])
                  ]
                )
              : _vm._e()
          ])
        ]),
        _c(
          "div",
          { staticClass: "row justify-end" },
          [
            _c(
              "vs-button",
              {
                staticClass: "mt-5 mr-5",
                attrs: {
                  "data-cy": "cancel",
                  color: "primary",
                  disabled: _vm.saving
                },
                on: {
                  click: function($event) {
                    return _vm.back()
                  }
                }
              },
              [_vm._v(" Cancelar ")]
            ),
            _c(
              "vs-button",
              {
                staticClass: "mt-5 mr-5",
                attrs: {
                  "data-cy": "save",
                  color: "success",
                  disabled: _vm.saving
                },
                on: {
                  click: function($event) {
                    return _vm.save()
                  }
                }
              },
              [
                _vm._v(" Crear "),
                _c("span", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.saving,
                      expression: "saving"
                    }
                  ],
                  staticClass: "spinner-border spinner-border-sm text-primary"
                })
              ]
            )
          ],
          1
        ),
        _c("repository-selector", {
          attrs: {
            "modal-id": "add-file-repository",
            "add-file": _vm.addFileRepo,
            files: _vm.formData.attachments,
            "remove-file": _vm.removeOthersFile
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("label", [_vm._v("Adjuntos")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }